import { useState, useEffect } from "react";

/**
 * Stato React persistito in sessionStorage.
 * Sopravvive allo smontaggio del componente (es. apri un giocatore e torni
 * indietro col browser): al rimontaggio lo stato — tab attiva, filtri, pagina —
 * viene ripristinato esattamente com'era.
 *
 * @param {string} key  chiave univoca (es. "mercato.section")
 * @param {*} initial   valore iniziale se non c'è nulla salvato
 */
export function usePersistedState(key, initial) {
    const [value, setValue] = useState(() => {
        try {
            const raw = sessionStorage.getItem(key);
            if (raw != null) return JSON.parse(raw);
        } catch {
            /* sessionStorage non disponibile o JSON corrotto: usa l'iniziale */
        }
        return initial;
    });

    useEffect(() => {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        } catch {
            /* quota piena o storage non disponibile: ignora */
        }
    }, [key, value]);

    return [value, setValue];
}
